import React from 'react';
import { Icon } from '@chakra-ui/react';

export const IconQuestion = (props) => (
  <Icon viewBox="0 0 31 30" fill="none" {...props}>
    <path
      d="M15.683 19.5415H14.6245C14.4196 19.5415 14.283 19.4049 14.283 19.2V14.6585C14.283 14.4878 14.4196 14.3171 14.6245 14.3171C15.0001 14.3171 15.3757 14.2829 15.7171 14.2488C16.1952 14.2146 16.6732 14.078 17.1171 13.8732C17.6976 13.5317 18.3805 12.7805 18.3805 11.6536C18.3805 9.74145 16.6732 8.78536 15.1025 8.78536C13.9757 8.78536 12.8147 9.19511 12.3025 10.6976C12.1318 11.1756 12.0976 11.6536 12.0976 12.1317C12.0976 12.3366 11.961 12.4732 11.7562 12.4732H10.5269C10.322 12.4732 10.1854 12.3024 10.1854 12.1317C10.2537 8.17072 13.361 7.14633 15.1366 7.14633C17.561 7.14633 20.2245 8.78536 20.2245 11.9268C20.2245 13.9415 19.0635 15.1707 18.0732 15.6829C17.6293 15.9219 17.0488 16.0927 16.3318 16.161C16.161 16.1951 16.0244 16.3317 16.0244 16.5024V19.2C16.0244 19.3707 15.8879 19.5415 15.683 19.5415ZM16.1269 21.0439V22.5122C16.1269 22.7171 15.9903 22.8536 15.7854 22.8536H14.522C14.3171 22.8536 14.1805 22.7171 14.1805 22.5122V21.0439C14.1805 20.839 14.3171 20.7024 14.522 20.7024H15.7854C15.9562 20.7024 16.1269 20.8732 16.1269 21.0439Z"
      fill="currentColor"
    />
    <path
      d="M15 29C22.732 29 29 22.732 29 15C29 7.26801 22.732 1 15 1C7.26801 1 1 7.26801 1 15C1 22.732 7.26801 29 15 29Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
